import serviceType from 'constants/serviceType';
import axiosClient from './aixosClient';
import { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';

const lotteryApi = {
    lotteryOffical4DBean(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'Official4DBean';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    lotteryCurrentIssue(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'read';
        return axiosClient.post(serviceType.LOTTERY_SERVICE, payload);
    },
    getOpenWinRecored(payload: { issue: string; lotteryid: number; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'gethistory';
        return axiosClient.post(serviceType.LOTTERY_SERVICE, payload);
    },
    lotteryWinOpenNumber(payload: { id: number; num: number; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'lotteryWinOpen';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    lotteryMMCWinOpenNumber(payload: { lotteryid: number; num: number; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'mmcwnum';
        return axiosClient.post(serviceType.LOTTERY_SERVICE, payload);
    },
    lotteryRecordBeanInfo(payload: { id: string; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'gameRecordDetail';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    lotteryCancelBet(payload: { id: string; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'gameRecord_cancelBet';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    lotteryInit(payload: { lotteryId: number; action: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = payload.action.search('VN') > -1 ? 'lotteryInit' : payload.action + 'Bean';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    lotteryCheckDualNumber(payload: { id: number; issue: string; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'checkDualNumber';
        return axiosClient.post(serviceType.LOTTERY_SERVICE, payload);
    },
    submitMultiple(payload: any, isFastLT?: boolean): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = `${isFastLT ? 'save' : 'betMultil'}`;
        return axiosClient.post(serviceType.LOTTERY_SERVICE, payload);
    },

    lotteryRecordBean(payload: { lotteryid: number; num?: number; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'gameRecord_btnSearch';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
};
export default lotteryApi;
